import React, { useRef } from 'react';
import speedometer from '../../assets/img/speedometer.svg';
import gasolinePump from '../../assets/img/gasoline-pump.svg'
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import Logo_final from '../../assets/img/Logo_final.png';
import printJS from 'print-js';

import { useHistory, useParams, useLocation } from "react-router-dom";
import API from "../../Services/BaseService";
import { useState } from 'react';
import { useEffect } from 'react';
import Loading from "../../Component/Loading/Loading";
import { useSelector } from 'react-redux';
import PageNotFound from '../FallBackUI/PageNotFound';

const InVoice = (props) => {
  const { backURL, billOfSales, year, make, model, gatePass, buyerId, price, soldDate, VinNo, inventoryNo, buyer_license, buyer_tax_id, achDate,
    selectedValues, bosFee } = props.location.state;
  console.log("billOfSales12", buyer_license)
  console.log("billOfSales14", buyer_tax_id)
  console.log("selectedValues", selectedValues)

  const history = useHistory();
  const sellerDetails = useSelector(state => state.LoginReducer.payload);
  const [sellerdetail, setSellerDetails] = useState([]);
  const [buyerdetails, setBuyerDetails] = useState([]);
  const [historyDetail, setHistoryDetail] = useState([]);
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();
  const [loading, setLoading] = useState(true);
  const [feeDetails, setFeeDetails] = useState("");

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  async function sellerInfo() {
    let request = {
      bill_of_sale_id: billOfSales,
      seller_id: sellerDetails.seller_id,
      seller_token: sellerDetails.seller_token,

    };
    const state = API.post('sellerdealerinfo/condition', request);
    state.then(res => {
      console.log("res==sellerInfo===>", res.data.data)
      if (res.data.success === true) {
        setSellerDetails(res.data.data);
        setLoading(false);
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }

    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }
  function buyerInfo() {
    let request = {
      bill_of_sale_id: billOfSales,
      seller_id: sellerDetails.seller_id,
      seller_token: sellerDetails.seller_token,
    };
    const state = API.post('user_profile/condition', request);
    state.then(res => {
      console.log("res==buyerInfo====>", res.data)
      if (res.data.success === true) {
        setBuyerDetails(res.data.data);
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }

    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }
  async function fetchBuyerFees() {
    console.log("inside fn");
    let request = {
      type: "Seller",
      seller_dealer_id: sellerDetails.seller_dealer_id,
      seller_id: sellerDetails.seller_id,
      seller_token: sellerDetails.seller_token

    };
    const state = API.post('sellerFees/condition', request);
    state.then(res => {
      console.log("res", res)
      if (res.data.success === true) {
        setFeeDetails(res.data.data);
        setLoading(false);
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }

    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  useEffect(() => {
    sellerInfo();
    buyerInfo();
    fetchBuyerFees();

  }, []);


  const getFeeDetails = () => {
    return feeDetails.length > 0 ? feeDetails
      .filter((data) => {
        // const range = data.fee_price.replaceAll('$',"").split("-")
        const range = data.from_price
        const rangeOne = data.to_price
        if (range[1] !== "up") {

          return Number(range) <= Number(price) && Number(price) <= Number(rangeOne)
        }
        else {
          return Number(range) <= Number(price)
        }

      }
      )[0]?.fee || 0
      : 0
  }

  const PrintPage = () => {
    console.log("print")
    printJS({
      printable: 'New Print',
      type: 'html',
      targetStyles: ['*']
    })
  }

  // const componentRef = useRef();
  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current,
  // });
  const totalPrice = Number(price) -
    (Number(selectedValues?.bos_seller_fee || 0) +
      Number(selectedValues?.bos_sellerothertotalcharge|| 0) +
      Number(selectedValues?.bos_car_charges|| 0));


  return (
    <div>

      <main id="main" class="inner-page">
        {errorFlag === true ? <PageNotFound error={errors} /> :
          <>
            {loading ? <Loading /> :

              <div id="invoice" class="fees">
                <div class="container" >
                  <div class="back-btn">
                    <a class="back-btn-primary" onClick={() => history.goBack()}><i class="bx bx-chevron-left"></i> Back</a>
                  </div>
                  <div class="feesblock">
                    <div class="invoiceBlock" >
                      <div class="row header">
                        <div class="col-lg-6 header_left"><img className='invoice-img' src={Logo_final} /></div>
                        <div class="col-lg-6 header_right">
                          <p>
                            8251 S Harlem Ave,Bridgeview, IL 60455 <br></br>
                            ursecondLot.com<br></br>
                            +1(708)777-2277
                          </p>
                        </div> </div>

                      <div class="section-title">
                        <h2>Invoice</h2>
                      </div>

                      <div class="headtable">
                        <div className='table-responsive'>
                          <table>
                            <tr>
                              <td colSpan="2"><span>Bill of sale # </span>{billOfSales}</td>
                              <td class="alignRight"><span class="autoWidth pr-1 ">Date : </span>{soldDate}</td></tr>                          
                            <tr>
                              <td><span>year </span>{year}</td>
                              <td><span>Make </span>{make}</td>
                              <td><span>Model  </span>{model}</td>
                            </tr>
                            <tr>
                              <td><span>Gate Pass Code </span>{gatePass}</td>
                              <td><span>Inventory # </span>{inventoryNo}</td>
                              <td><span>Vin #  </span>{VinNo}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      <div class="contenttable">
                        {sellerdetail.length > 0 ? sellerdetail.map((item, index) =>
                          <div>
                            <table class="infotable">
                              <thead>
                                <tr>
                                  <th>Seller Info</th>
                                </tr>
                              </thead>
                              <tr><td><span>Seller Dealer Name</span>{item.sellerdealerName}</td></tr>
                              <tr><td><span>Seller Name</span>{item.sellerName}</td></tr>
                              <tr><td><span className="addressLable">Address </span><div className="addDetails">{item.seller_address},<br></br> {item.state_name},<br></br> {item.city_name},<br></br> {item.zipcode} </div></td></tr>
                              {achDate == "" || achDate == undefined || achDate == null ? <tr><td><span class="">Date of Fund</span><span class="redText">Not yet</span></td></tr> :
                                <tr><td><span class="">Date of Fund</span><span class="greenText">{achDate}</span></td></tr>}
                              {/* <tr><td><span>Contact </span>{item.phone_no}</td></tr>	
               <tr><td><span>Email id </span>{item.email}</td></tr>		  		   */}

                            </table>
                          </div>) : ""}

                        {buyerdetails.length > 0 ? buyerdetails.map((item, index) =>
                          <div>
                            <table class="infotable">
                              <thead>
                                <tr>
                                  <th>Buyer Info</th>
                                </tr>
                              </thead>

                              <tr><td><span>Buyer Dealer Name </span>{item.buyerdealerName}</td></tr>
                              <tr><td><span>Buyer Name </span>{item.buyerName}</td></tr>
                              <tr><td><span className="addressLable">Address </span><div className="addDetails">{item.dealeraddress},<br></br> {item.state_name},<br></br> {item.city_name},<br></br> {item.zipcode}</div></td></tr>
                              <tr><td><span>License </span>{item.buyerlicense}</td></tr>
                              <tr><td><span>Tax # </span>{item.buyer_tax_id}</td></tr>

                            </table>
                          </div>) : ""}

                      </div>


                      <div class="feestableBlock">
                        <div class="feestable">
                          <table>
                            <thead>
                              <tr>
                                <th>Vehicle Information</th>
                                <th class="priceCol">Price</th>
                              </tr>
                            </thead>
                            <tr>
                              <td>Vehicle Price
                                <p>{make} ({model} model)</p>
                              </td>
                              <td><span>$ {price}</span></td>
                            </tr>
                            <tr>
                              <td>Sell Fee</td>
                              <td><span>$ -{selectedValues?.bos_seller_fee}</span></td>
                            </tr>
                            <tr>
                              <td>Other Charges</td>
                              <td><span>$ -{selectedValues?.bos_sellerothertotalcharge}</span></td>
                            </tr>
                            <tr>
                              <td>Miscellaneous Charges</td>
                              <td><span>$ -{selectedValues?.bos_car_charges}</span></td>
                            </tr>

                            <tfoot>
                              <tr>
                                <td>Amount due to the seller</td>
                                <td><span>$ {Number(totalPrice)}</span></td>
                                {/* <td><span>$  {price - selectedValues?.bos_seller_fee + selectedValues?.bos_sellerothertotalcharges + selectedValues?.bos_car_charges}</span></td> */}
                                {/* <td><span>$ {price  - getFeeDetails() + 0 + 0}</span></td> */}
                              </tr>
                            </tfoot>

                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }</>}
        <div class="hideContent">
          <div class="invoiceBlock printPdf" id="New Print" >

            <div class="row header">
              <div class="col-lg-6 col-md-6 col-sm-6 col-6 header_left"><img src={Logo_final} /></div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-6 header_right">
                <p>
                  123Fairview Ave, El Monte,US, 91732 <br></br>
                  ursecondLot.com<br></br>
                  +1(708)777-2277
                </p>
              </div> </div>

            <div class="section-title pb-0">
              <h2>Invoice</h2>
            </div>

            <div class="headtable">
              {/* {historyDetail.length > 0 ? historyDetail.map((item) => */}
              <div>
                <table>
                  <tr>
                    <td colSpan="2"><span>Bill of sale # </span>{billOfSales}</td>
                    <td class="alignRight"><span class="autoWidth pr-1 inputtime">Date :</span>{soldDate}</td></tr>
                  {/* <td>Date {soldDate}</td></tr> */}
                  <tr>
                    <td><span>year </span>{year}</td>
                    <td><span>Make </span>{make}</td>
                    <td><span>Model  </span>{model}</td>
                  </tr>
                  <tr>
                    <td><span>Gate Pass Code </span>{gatePass}</td>
                    <td><span>Inventory # </span>{inventoryNo}</td>
                    <td><span>Vin #  </span>{VinNo}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="contenttable">
              {sellerdetail.length > 0 ? sellerdetail.map((item, index) =>
                <div>
                  <table class="infotable01">
                    <thead>
                      <tr>
                        <th>Seller Info</th>
                      </tr>
                    </thead>
                    <tr><td><span>Seller Dealer Name</span>{item.sellerdealerName}</td></tr>
                    <tr><td><span>Seller Name</span>{item.sellerName}</td></tr>
                    <tr><td><span className="addressLable">Address </span><div className="addDetails">{item.seller_address},<br></br> {item.state_name},<br></br> {item.city_name},<br></br> {item.zipcode} </div></td></tr>
                    {achDate == "" || achDate == undefined || achDate == null ? <tr><td><span class="">Date of Fund</span><span class="redText">Not yet</span></td></tr> :
                      <tr><td><span class="">Date of Fund</span><span class="greenText">{achDate}</span></td></tr>}
                    {/* <tr><td><span>Contact </span>{item.phone_no}</td></tr>	
               <tr><td><span>Email id </span>{item.email}</td></tr>		  		   */}

                  </table>
                </div>) : ""}

              {buyerdetails.length > 0 ? buyerdetails.map((item, index) =>
                <div>
                  <table class="infotable01">
                    <thead>
                      <tr>
                        <th>Buyer Info</th>
                      </tr>
                    </thead>

                    <tr><td><span>Buyer Dealer Name </span>{item.buyerdealerName}</td></tr>
                    <tr><td><span>Buyer Name </span>{item.buyerName}</td></tr>
                    <tr><td><span className="addressLable">Address </span><div className="addDetails">{item.dealeraddress},<br></br> {item.state_name},<br></br> {item.city_name},<br></br> {item.zipcode}</div></td></tr>
                    <tr><td><span>License </span>{item?.buyerlicense}</td></tr>
                    <tr><td><span>Tax # </span>{item?.buyer_tax_id}</td></tr>

                  </table>
                </div>) : ""}

            </div>


            <div class="feestableBlock">
              <div class="feestable">
                <table>
                  <thead>
                    <tr>
                      <th>Vehicle Information</th>
                      <th class="priceCol">Price</th>
                    </tr>
                  </thead>
                  <tr>
                    <td>Vehicle Price
                      <p>{make} ({model} model)</p>
                    </td>
                    <td><span>$ {price}</span></td>
                  </tr>
                  <tr>
                    <td>Sell Fee</td>
                    <td><span>$ -{selectedValues?.bos_seller_fee}</span></td>
                  </tr>
                  <tr>
                    <td>Other Charges</td>
                    <td><span>$  -{selectedValues?.bos_sellerothertotalcharge}</span></td>
                  </tr>
                  <tr>
                    <td>Miscellaneous Charges</td>
                    <td><span>$  -{selectedValues?.bos_car_charges}</span></td>
                  </tr>

                  <tfoot>
                    <tr>
                      <td>Amount due to the seller</td>
                      <td><span>$ {totalPrice}</span></td>
                      {/* <td><span>$  {selectedValues?.bos_sellertotalamount}</span></td> */}
                      {/* <td><span>$ {price  - getFeeDetails() + 0 + 0}</span></td> */}
                    </tr>
                  </tfoot>

                </table>

              </div>
            </div>
          </div>
        </div>
        <div className='print-btn'>
        <button class="cta-btns" onClick={PrintPage}>Print</button>
        </div>

        <section id="playstoreBlock" class="playstoreBlock">
          <div class="container">


            <div class="row content">
              <div class="col-lg-12">
                <img src={appstore.png} />
                <img src={googleplay} />
              </div>

            </div>
          </div>
        </section>

      </main>

    </div>
  )
}
export default InVoice;